export default "__VITE_ASSET__fcHr7xdc__ 480w, __VITE_ASSET__DVRDEegn__ 768w, __VITE_ASSET__D4Q4F6Lr__ 1200w, __VITE_ASSET__Bneq3kbb__ 1368w";